import { useLocation, useNavigate } from 'react-router-dom';
import CommonAuthComponent from './CommonAuthComponent';
import emailBoxIcon from '/icons/email-box.svg';

const ShowYourUsername = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const email = location.state?.email || '';

  return (
    <CommonAuthComponent maxWidthClass="max-w-md">
      <div className="flex flex-col items-center space-y-6">
        <div className="flex items-center justify-center bg-white mt-8">
          <img src={emailBoxIcon} alt="Email" className="h-[115px] w-[115px]" />
        </div>

        <h1 className="text-[28px] text-center font-normal">
          Here's Your Username
        </h1>

        <p className="text-center leading-relaxed text-[18px] font-normal !mb-2">
          We found the account associated with the details you entered.
        </p>
        <p className="text-center leading-relaxed text-[18px] font-normal">
          Your email is:
          <br />
          <span className="font-bold">{email || 'Not Available'}</span>
        </p>

        <button
          onClick={() => navigate('/login')}
          className="w-full inline-flex rounded-[4px] border transition-all duration-300 text-body-md items-center font-semibold justify-center px-6 py-3.5 bg-REELTeal border border-transparent hover:bg-teal-200 text-white"
        >
          Back to Login
        </button>
      </div>
    </CommonAuthComponent>
  );
};

export default ShowYourUsername;
